module.exports = __webpack_public_path__ + "static/media/holytrinity.1a4c8e9c.webp";